export enum QUERY_KEYS {
  createCompanyUser = 'create-company-user',
  createCompanyWidget = 'create-company-widget',
  deleteCompanyUser = 'delete-company-user',
  getCompany = 'company',
  getCompanyBookingStats = 'company-booking-stats',
  getCompanyChannels = 'company-channels-by-id',
  getCompanyCheckoutFormPresets = 'company-checkout-form-presets',
  getCompanyClubs = 'company-clubs',
  getCompanyCurrencies = 'company-currencies',
  getCompanyDelayedDeliverySettings = 'company-delayed-delivery-settings',
  getCompanyResaleSettings = 'company-resale-settings',
  getCompanyTicketAlertsSettings = 'company-ticket-alerts-settings',
  getCompanyEventStats = 'company-event-stats',
  getCompanyInfo = 'company-info',
  getCompanyIntegrations = 'company-ar-token',
  getCompanyPermissions = 'company-permissions',
  getCompanyRolePermissions = 'company-role-permissions',
  getCompanyRoles = 'company-roles',
  getCompanyStats = 'company-stats',
  getCompanyUserInfo = 'company-user-info',
  getCompanyUserList = 'get-company-user-list',
  getCompanyVenues = 'company-venues',
  getCompanyTicketsLeftThreshold = 'company-tickets-left-threshold',
  getCompanyVatRates = 'company-vat-rates',
  getCompanyWidget = 'company-widget-settings',
  getCountries = 'get-company-countries',
  patchCompanyVatRates = 'patch-company-vat-rates',
  requestNewVenue = 'request-new-venue',
  setCompanyGallery = 'set-company-gallery',
  updateCompanyCheckoutFormPresets = 'update-company-checkout-form-presets',
  updateCompanyDelayedDeliverySettings = 'update-company-delayed-delivery-settings',
  updateCompanyResaleSettings = 'update-company-resale-settings',
  updateCompanyTicketAlertsSettings = 'update-company-ticket-alerts-settings',
  updateCompanyInfo = 'update-company-info',
  updateCompanyIntegrations = 'update-company-ar-token',
  updateCompanyLogo = 'update-company-logo',
  updateCompanyTicketsLeftThreshold = 'update-company-tickets-left-threshold',
  updateCompanyWidget = 'update-company-widget',
  updateUserRole = 'update-user-role',
}
